import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import useAuthStore from '~/stores/auth'
import { ContentType } from '~/models/Content/ContentType'

export default () => {
  const { isAuthenticated } = storeToRefs(useAuthStore())

  const emptyQuery = { text: '*' }
  const contentPath = 'aunivers/search'
  const previewPath = 'aunivers/search/preview'

  const searchPath = computed(() => isAuthenticated.value ? contentPath : previewPath)

  // Fields necessary to build a card
  const cardFields = [
    'title',
    'short_title',
    'level_tag',
    'grades',
    'levels',
    'subjects',
    'label',
    'file',
    'metadata',
    'thumbnail',
    'image',
    'view_mode',
    'video',
    'link_external',
    'activity_tag',
    'file_url',
    'new_until',
    'ean',
    'genre',
  ]

  // Default content types to query
  const defaultContentTypes = [
    ContentType.ProductArticle,
    ContentType.ProductPart,
    ContentType.LearningPath,
    ContentType.Video,
    ContentType.File,
    ContentType.BookReader,
    ContentType.Presentation,
    ContentType.FlytTask,
    ContentType.PdfBook,
    ContentType.Flashcards,
    ContentType.ProductHeader,
    ContentType.ProductPackage,
    ContentType.TeacherArticle,
    ContentType.Article,
    ContentType.Product,
    ContentType.Scene,
  ]

  return {
    searchPath,
    contentPath,
    previewPath,
    emptyQuery,
    cardFields,
    defaultContentTypes,
  }
}
